import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';

@Component({
  selector: 'pagination-bootstrap',
  templateUrl: './pagination-bootstrap.component.html',
  styleUrls: ['./pagination-bootstrap.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush, // copied from the original pagination component
})
export class PaginationBootstrapComponent implements OnInit {

  @Input() public id: string;
  @Input() public maxSize: number = 7;
  @Output() public pageChange: EventEmitter<number> = new EventEmitter<number>();
  @ViewChild('p') paginator;

  public ngOnInit(): void {
    if (this.id != '' && this.id !== undefined) {
      const s = localStorage.getItem('paginator-index-'+this.id);
      if ( s !== undefined && s != null) {
        this.paginator.setCurrent(parseInt(s));
      }
    }
  }

  public store(i: number): void {
    if (this.id != '' && this.id !== undefined) { 
      localStorage.setItem('paginator-index-'+this.id, i+"");
    }
  }

  public doPageChange(event) {
    this.store(event);
    this.pageChange.emit(event)
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/shared/pagination-bootstrap/pagination-bootstrap.component.ts